import React from "react";
import {ListItem, Paragraph, SectionHeading} from "../PrivacyPolicyText";

const UseAndDisclosureSection = () => (
  <>
    <SectionHeading>{"How We Use Your Information"}</SectionHeading>

    <Paragraph>
      {"We use information that We collect about you or that you provide to us, including any personal information:"}
    </Paragraph>

    <ListItem>{"To present our Website and our Services or Challenges to you."}</ListItem>

    <ListItem>{"To provide you with Evenplay’s products and services."}</ListItem>

    <ListItem>{"To improve our Website and/or Applications."}</ListItem>

    <ListItem>{"To provide you with information, products or services that you request from us."}</ListItem>

    <ListItem>{"To notify you about changes to our Website and/or Applications."}</ListItem>

    <ListItem>{"To allow you to participate in interactive features on our Website and/or Applications."}</ListItem>

    <ListItem>{"To provide customer support."}</ListItem>

    <ListItem>{"For Internal recordkeeping."}</ListItem>

    <ListItem>{"For Market research."}</ListItem>

    <ListItem>{"To investigate, deter, and protect against fraudulent, unauthorized or illegal activity."}</ListItem>

    <ListItem>{"To inform you about promotions, events, and news related to our Website and Applications."}</ListItem>

    <ListItem>{"To contact you with respect to our Website and Applications."}</ListItem>

    <ListItem>{"In any other way We may describe when you provide the information."}</ListItem>

    <ListItem>{"To fulfill any other purpose for which you provide it."}</ListItem>

    <ListItem>{"For any other purpose with your consent."}</ListItem>

    <ListItem withBottomMargin>
      {"We may also use your information to contact you about goods and services that may be of interest to you. For more information, see Choices About How We Use and Disclose Your Information."}
    </ListItem>

    <SectionHeading>{"Disclosure of Your Information"}</SectionHeading>

    <Paragraph>
      {"We may disclose aggregated information about our users, and information that does not identify any individual, without restriction."}
    </Paragraph>

    <Paragraph>
      {"We may disclose personal information that We collect or you provide as described in this privacy Policy:"}
    </Paragraph>

    <ListItem>{"To our subsidiaries and affiliates."}</ListItem>

    <ListItem>{"To our employees on a need-to-know basis."}</ListItem>

    <ListItem>
      {"To contractors, service providers, and other third parties We use to support our business and who are bound by contractual obligations to keep personal information confidential and use it only for the purposes for which We disclose it to them."}
    </ListItem>

    <ListItem>
      {"To a buyer or other successor in the event of a merger, divestiture, restructuring, reorganization, dissolution, or other sale or transfer of some or all of Evenplay’ assets, whether as a going concern or as part of bankruptcy, liquidation, or similar proceeding, in which personal information held by Evenplay about our Service users is among the assets transferred."}
    </ListItem>

    <ListItem>{"To fulfill the purpose for which you provide it."}</ListItem>

    <ListItem>
      {"If your earnings from Challenges exceed a certain threshold, in accordance with our interpretation of applicable law, We will disclose the amount of your earnings and related information to the United States Internal Revenue Service and other appropriate taxing authorities."}
    </ListItem>

    <ListItem>
      {"From time to time, We may also need to share your information with professional advisers, including lawyers, auditors, bankers, insurers and consultants, in order to obtain advice or other professional services from them. Such advisers are bound by legal and/or contractual duties of confidentiality and other prohibitions against disclosure of personal information."}
    </ListItem>

    <ListItem>
      {"Co-Branded Partners are companies with whom We may jointly offer a service or feature. You can tell when you are accessing a service or feature offered by a Co-Branded Partner because the Co-Branded Partner's name will be featured prominently. You may be asked to provide information about yourself to register for a service offered by a Co-Branded Partner. In doing so, you may be providing your information to both Us and the Co-Branded Partner, or We may share your information with the Co-Branded Partner. Please note that the Co-Branded Partner's privacy policy may also apply to its use of your information. We are not responsible for the practices used by Co-Branded Partners. In addition, by using our Website, Applications, and Services and/or Challenges, you acknowledge and agree that We are not responsible for and do not have control over any Co-Branded Partners."}
    </ListItem>

    <ListItem>{"For any other purpose disclosed by Us when you provide the information."}</ListItem>

    <ListItem withBottomMargin>{"With your consent."}</ListItem>

    <Paragraph>{"We may also disclose your personal information:"}</Paragraph>

    <ListItem>
      {"To comply with any court order, law, or legal process, including to respond to any government or regulatory request."}
    </ListItem>

    <ListItem>{"As required under other agreements, including for billing and collection purposes."}</ListItem>

    <ListItem withBottomMargin>
      {"If We believe disclosure is necessary or appropriate to protect the rights, property, or safety of Evenplay, our customers, or others."}
    </ListItem>
  </>
);

export default UseAndDisclosureSection;
